"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.spectrumReducer = exports.initState = exports.initialState = exports.getInitialState = exports.getDefaultViewState = void 0;
const uuid_1 = require("@lukeed/uuid");
const immer_1 = require("immer");
const nmr_correlation_1 = require("nmr-correlation");
const Constants_1 = require("../panels/SummaryPanel/CorrelationTable/Constants");
const AssignmentsActions = __importStar(require("./actions/AssignmentsActions"));
const CorrelationsActions = __importStar(require("./actions/CorrelationsActions"));
const DatabaseActions = __importStar(require("./actions/DatabaseActions"));
const DimensionsActions = __importStar(require("./actions/DimensionsActions"));
const DomainActions = __importStar(require("./actions/DomainActions"));
const FiltersActions = __importStar(require("./actions/FiltersActions"));
const IntegralsActions = __importStar(require("./actions/IntegralsActions"));
const LoadActions = __importStar(require("./actions/LoadActions"));
const MoleculeActions = __importStar(require("./actions/MoleculeActions"));
const PeaksActions = __importStar(require("./actions/PeaksActions"));
const PreferencesActions = __importStar(require("./actions/PreferencesActions"));
const RangesActions = __importStar(require("./actions/RangesActions"));
const SpectraAnalysisActions = __importStar(require("./actions/SpectraAnalysisAction"));
const SpectrumsActions = __importStar(require("./actions/SpectrumsActions"));
const ToolsActions = __importStar(require("./actions/ToolsActions"));
const ZonesActions = __importStar(require("./actions/ZonesActions"));
function getDefaultViewState() {
    return {
        molecules: {},
        ranges: {},
        zones: {},
        peaks: {},
        spectra: {
            activeSpectra: {},
            activeTab: '',
            showLegend: false,
            selectReferences: {},
        },
        zoom: {
            levels: {},
        },
        verticalAlign: {},
        predictions: {},
        currentSimulatedSpectrumKey: null,
    };
}
exports.getDefaultViewState = getDefaultViewState;
const getInitialState = () => ({
    actionType: 'INITIALIZE_NMRIUM',
    data: [],
    tempData: null,
    xDomain: [],
    yDomain: [],
    yDomains: {},
    xDomains: {},
    originDomain: {
        xDomain: [],
        yDomain: [],
        xDomains: {},
        yDomains: {},
        shareYDomain: false,
    },
    integralsYDomains: {},
    width: 0,
    height: 0,
    margin: {
        top: 10,
        right: 20,
        bottom: 50,
        left: 0,
    },
    mode: 'RTL',
    molecules: [],
    view: getDefaultViewState(),
    history: {
        past: [],
        present: null,
        future: [],
        hasUndo: false,
        hasRedo: false,
    },
    isLoading: false,
    keysPreferences: {},
    displayerMode: '1D',
    correlations: {},
    displayerKey: '',
    zoom: {
        history: {},
    },
    toolOptions: {
        selectedTool: 'zoom',
        selectedOptionPanel: null,
        data: {
            baselineCorrection: {
                options: {},
                zones: [],
                livePreview: true,
            },
            apodizationOptions: {},
            pivot: { value: 0, index: 0 },
            zonesNoiseFactor: 1,
            activeFilterID: null,
            predictionIndex: 0,
        },
    },
    usedColors: { '1d': [], '2d': [] },
});
exports.getInitialState = getInitialState;
exports.initialState = (0, exports.getInitialState)();
function initState(state) {
    const displayerKey = (0, uuid_1.v4)();
    const correlations = (0, nmr_correlation_1.buildCorrelationData)([], {
        tolerance: Constants_1.DefaultTolerance,
    });
    return {
        ...state,
        correlations,
        displayerKey,
        history: {},
    };
}
exports.initState = initState;
function innerSpectrumReducer(draft, action) {
    if (!['LOAD_DROP_FILES', 'INITIATE'].includes(action.type)) {
        draft.actionType = action.type;
    }
    try {
        switch (action.type) {
            case 'INITIATE':
                return LoadActions.handleInitiate(draft, action);
            case 'LOAD_DROP_FILES':
                return LoadActions.handleLoadDropFiles(draft, action);
            case 'SET_LOADING_FLAG':
                return LoadActions.handleSetIsLoading(draft, action);
            case 'ADD_PEAK':
                return PeaksActions.handleAddPeak(draft, action);
            case 'ADD_PEAKS':
                return PeaksActions.handleAddPeaks(draft, action);
            case 'DELETE_PEAK':
                return PeaksActions.handleDeletePeak(draft, action);
            case 'AUTO_PEAK_PICKING':
                return PeaksActions.handleAutoPeakPicking(draft, action);
            case 'OPTIMIZE_PEAKS':
                return PeaksActions.handleOptimizePeaks(draft, action);
            case 'CHANGE_PEAK_SHAPE':
                return PeaksActions.handleChangePeakShape(draft, action);
            case 'TOGGLE_PEAKS_VIEW_PROPERTY':
                return PeaksActions.handleTogglePeaksViewProperty(draft, action);
            case 'TOGGLE_PEAKS_DISPLAYING_MODE':
                return PeaksActions.handleChangePeaksDisplayingMode(draft);
            case 'ADD_INTEGRAL':
                return IntegralsActions.handleAddIntegral(draft, action);
            case 'DELETE_INTEGRAL':
                return IntegralsActions.handleDeleteIntegral(draft, action);
            case 'RESIZE_INTEGRAL':
            case 'CHANGE_INTEGRAL':
                return IntegralsActions.handleChangeIntegral(draft, action);
            case 'CHANGE_INTEGRAL_SUM':
                return IntegralsActions.handleChangeIntegralSum(draft, action);
            case 'CHANGE_INTEGRALS_SUM_FLAG':
                return IntegralsActions.handleChangeIntegralsSumFlag(draft);
            case 'CHANGE_INTEGRAL_RELATIVE':
                return IntegralsActions.handleChangeIntegralsRelativeValue(draft, action);
            case 'CUT_INTEGRAL':
                return IntegralsActions.handleCutIntegral(draft, action);
            case 'SET_X_DOMAIN':
                return DomainActions.handleSetXDomain(draft, action);
            case 'SET_Y_DOMAIN':
                return DomainActions.handleSetYDomain(draft, action);
            case 'MOVE':
                return DomainActions.handleMoveOverXAxis(draft, action);
            case 'SET_DIMENSIONS':
                return DimensionsActions.handleSetDimensions(draft, action);
            case 'SHIFT_SPECTRUM':
                return FiltersActions.handleShiftSpectrumAlongXAxis(draft, action);
            case 'APPLY_APODIZATION_FILTER':
                return FiltersActions.handleApplyApodizationFilter(draft, action);
            case 'CALCULATE_APODIZATION_FILTER':
                return FiltersActions.handleCalculateApodizationFilter(draft, action);
            case 'APPLY_ZERO_FILLING_FILTER':
                return FiltersActions.handleApplyZeroFillingFilter(draft, action);
            case 'CALCULATE_ZERO_FILLING_FILTER':
                return FiltersActions.handleCalculateZeroFillingFilter(draft, action);
            case 'APPLY_FFT_FILTER':
                return FiltersActions.handleApplyFFTFilter(draft);
            case 'APPLY_FFT_DIMENSION_1_FILTER':
                return FiltersActions.handleApplyFFtDimension1Filter(draft);
            case 'APPLY_FFT_DIMENSION_2_FILTER':
                return FiltersActions.handleApplyFFtDimension2Filter(draft);
            case 'APPLY_MANUAL_PHASE_CORRECTION_FILTER':
                return FiltersActions.handleApplyManualPhaseCorrectionFilter(draft, action);
            case 'CALCULATE_MANUAL_PHASE_CORRECTION_FILTER':
                return FiltersActions.handleCalculateManualPhaseCorrection(draft, action);
            case 'APPLY_AUTO_PHASE_CORRECTION_FILTER':
                return FiltersActions.handleApplyAutoPhaseCorrectionFilter(draft);
            case 'APPLY_ABSOLUTE_FILTER':
                return FiltersActions.handleApplyAbsoluteFilter(draft);
            case 'APPLY_BASE_LINE_CORRECTION_FILTER':
                return FiltersActions.handleBaseLineCorrectionFilter(draft, action);
            case 'CALCULATE_BASE_LINE_CORRECTION_FILTER':
                return FiltersActions.handleCalculateBaseLineCorrection(draft, action);
            case 'ENABLE_FILTER':
                return FiltersActions.handleEnableFilter(draft, action);
            case 'DELETE_FILTER':
                return FiltersActions.handleDeleteFilter(draft, action);
            case 'DELETE_SPECTRA_FILTER':
                return FiltersActions.handleDeleteSpectraFilter(draft, action);
            case 'SET_FILTER_SNAPSHOT':
                return FiltersActions.handleSetFilterSnapshotHandler(draft, action);
            case 'APPLY_SIGNAL_PROCESSING_FILTER':
                return FiltersActions.handleSignalProcessingFilter(draft, action);
            case 'ADD_EXCLUSION_ZONE':
                return FiltersActions.handleAddExclusionZone(draft, action);
            case 'DELETE_EXCLUSION_ZONE':
                return FiltersActions.handleDeleteExclusionZone(draft, action);
            case 'CHANGE_SPECTRUM_VISIBILITY':
                return SpectrumsActions.handleChangeSpectrumVisibilityById(draft, action);
            case 'CHANGE_SPECTRA_VISIBILITY_BY_NUCLEUS':
                return SpectrumsActions.handleChangeSpectraVisibilityByNucleus(draft, action);
            case 'CHANGE_ACTIVE_SPECTRUM':
                return SpectrumsActions.handleChangeActiveSpectrum(draft, action);
            case 'CHANGE_SPECTRUM_SETTING':
                return SpectrumsActions.handleChangeSpectrumSetting(draft, action);
            case 'ALIGN_SPECTRA':
                return SpectrumsActions.handleAlignSpectraHandler(draft, action);
            case 'DELETE_SPECTRA':
                return SpectrumsActions.handleDeleteSpectra(draft, action);
            case 'ADD_MISSING_PROJECTION':
                return SpectrumsActions.handleAddMissingProjectionHandler(draft, action);
            case 'GENERATE_SPECTRUM_FROM_PUBLICATION_STRING':
                return SpectrumsActions.handleGenerateSpectrumFromPublicationStringHandler(draft, action);
            case 'IMPORT_SPECTRA_META_INFO':
                return SpectrumsActions.handleImportSpectraMetaInfo(draft, action);
            case 'TOGGLE_SPECTRA_LEGEND':
                return SpectrumsActions.handleToggleSpectraLegend(draft);
            case 'RECOLOR_SPECTRA_COLOR':
                return SpectrumsActions.handleRecolorSpectraBasedOnDistinctValue(draft, action);
            case 'ORDER_SPECTRA':
                return SpectrumsActions.handleOrderSpectra(draft, action);
            case 'SIMULATE_SPECTRUM':
                return SpectrumsActions.handleSimulateSpectrum(draft, action);
            case 'SET_SELECTED_TOOL':
                return ToolsActions.setSelectedTool(draft, action);
            case 'RESET_SELECTED_TOOL':
                return ToolsActions.handleResetSelectedTool(draft);
            case 'FULL_ZOOM_OUT':
                return ToolsActions.zoomOut(draft, action);
            case 'TOGGLE_REAL_IMAGINARY_VISIBILITY':
                return ToolsActions.handleToggleRealImaginaryVisibility(draft);
            case 'SET_ZOOM':
                return ToolsActions.handleZoom(draft, action);
            case 'SET_SPECTRA_SAME_TOP':
                return ToolsActions.setSpectraSameTopHandler(draft);
            case 'RESET_SPECTRA_SCALE':
                return ToolsActions.resetSpectraScale(draft);
            case 'CHANGE_SPECTRUM_DISPLAY_VIEW_MODE':
                return ToolsActions.handleChangeSpectrumDisplayMode(draft);
            case 'BRUSH_END':
                return ToolsActions.handleBrushEnd(draft, action);
            case 'SET_VERTICAL_INDICATOR_X_POSITION':
                return ToolsActions.setVerticalIndicatorXPosition(draft, action);
            case 'SET_SPECTRUMS_VERTICAL_ALIGN':
                return ToolsActions.setSpectrumsVerticalAlign(draft);
            case 'SET_ACTIVE_TAB':
                return ToolsActions.handelSetActiveTab(draft, action);
            case 'ADD_BASE_LINE_ZONE':
                return ToolsActions.handleAddBaseLineZone(draft, action);
            case 'DELETE_BASE_LINE_ZONE':
                return ToolsActions.handleDeleteBaseLineZone(draft, action);
            case 'SET_2D_LEVEL':
                return ToolsActions.levelChangeHandler(draft, action);
            case 'ADD_MOLECULE':
                return MoleculeActions.handleAddMolecule(draft, action);
            case 'ADD_MOLECULES':
                return MoleculeActions.handleAddMolecules(draft, action);
            case 'SET_MOLECULE':
                return MoleculeActions.handleSetMolecule(draft, action);
            case 'CHANGE_MOLECULE_LABEL':
                return MoleculeActions.handleChangeMoleculeLabel(draft, action);
            case 'DELETE_MOLECULE':
                return MoleculeActions.handleDeleteMolecule(draft, action);
            case 'PREDICT_SPECTRA':
                return MoleculeActions.handlePredictSpectraFromMolecule(draft, action);
            case 'FLOAT_MOLECULE_OVER_SPECTRUM':
                return MoleculeActions.handleFloatMoleculeOverSpectrum(draft, action);
            case 'TOGGLE_MOLECULE_ATOM_NUMBER':
                return MoleculeActions.handleToggleMoleculeAtomsNumbers(draft, action);
            case 'CHANGE_FLOAT_MOLECULE_POSITION':
                return MoleculeActions.handleChangeFloatMoleculePosition(draft, action);
            case 'SET_CORRELATIONS_MF':
                return CorrelationsActions.handleSetMF(draft, action);
            case 'SET_CORRELATIONS_TOLERANCE':
                return CorrelationsActions.handleSetTolerance(draft, action);
            case 'SET_CORRELATION':
                return CorrelationsActions.handleSetCorrelation(draft, action);
            case 'SET_CORRELATIONS':
                return CorrelationsActions.handleSetCorrelations(draft, action);
            case 'DELETE_CORRELATION':
                return CorrelationsActions.handleDeleteCorrelation(draft, action);
            case 'AUTO_RANGES_DETECTION':
                return RangesActions.handleAutoRangesDetection(draft, action);
            case 'ADD_RANGE':
                return RangesActions.handleAddRange(draft, action);
            case 'DELETE_RANGE':
                return RangesActions.handleDeleteRange(draft, action);
            case 'DELETE_1D_SIGNAL':
                return RangesActions.handleDeleteSignal(draft, action);
            case 'RESIZE_RANGE':
                return RangesActions.handleResizeRange(draft, action);
            case 'CHANGE_RANGE_SUM':
                return RangesActions.handleChangeRangeSum(draft, action);
            case 'CHANGE_RANGES_SUM_FLAG':
                return RangesActions.handleChangeRangesSumFlag(draft);
            case 'CHANGE_RANGE_RELATIVE':
                return RangesActions.handleChangeRangeRelativeValue(draft, action);
            case 'CHANGE_RANGE_SIGNAL_VALUE':
                return RangesActions.handleChangeRangeSignalValue(draft, action);
            case 'CHANGE_RANGE_SIGNAL_KIND':
                return RangesActions.handleChangeRangeSignalKind(draft, action);
            case 'SAVE_EDITED_RANGE':
                return RangesActions.handleSaveEditedRange(draft, action);
            case 'UNLINK_RANGE':
                return RangesActions.handleUnlinkRange(draft, action);
            case 'SET_DIAID_RANGE':
                return RangesActions.handleSetDiaIDRange(draft, action);
            case 'UPDATE_RANGE':
                return RangesActions.handleUpdateRange(draft, action);
            case 'TOGGLE_RANGES_VIEW_PROPERTY':
                return RangesActions.handleToggleRangesViewProperty(draft, action);
            case 'AUTO_RANGES_SPECTRA_PICKING':
                return RangesActions.handleAutoSpectraRangesDetection(draft);
            case 'CUT_RANGE':
                return RangesActions.handleCutRange(draft, action);
            case 'TOGGLE_RANGES_PEAKS_DISPLAYING_MODE':
                return RangesActions.handleChangePeaksDisplayingMode(draft);
            case 'DELETE_RANGE_PEAK':
                return RangesActions.handleDeleteRangePeak(draft, action);
            case 'SET_KEY_PREFERENCES':
                return PreferencesActions.handleSetKeyPreferences(draft, action);
            case 'APPLY_KEY_PREFERENCES':
                return PreferencesActions.handleApplyKeyPreferences(draft, action);
            case 'AUTO_ZONES_DETECTION':
                return ZonesActions.handleAutoZonesDetection(draft, action);
            case 'CHANGE_ZONES_NOISE_FACTOR':
                return ZonesActions.handleChangeZonesFactor(draft, action);
            case 'ADD_2D_ZONE':
                return ZonesActions.handleAdd2dZone(draft, action);
            case 'DELETE_2D_ZONE':
                return ZonesActions.handleDeleteZone(draft, action);
            case 'DELETE_2D_SIGNAL':
                return ZonesActions.handleDeleteSignal(draft, action);
            case 'SET_2D_SIGNAL_PATH_LENGTH':
                return ZonesActions.handleSetSignalPathLength(draft, action);
            case 'CHANGE_ZONE_SIGNAL_VALUE':
                return ZonesActions.handleChangeZoneSignalDelta(draft, action);
            case 'CHANGE_ZONE_SIGNAL_KIND':
                return ZonesActions.handleChangeZoneSignalKind(draft, action);
            case 'UNLINK_ZONE':
                return ZonesActions.handleUnlinkZone(draft, action);
            case 'SET_ZONE_DIAID':
                return ZonesActions.handleSetDiaIDZone(draft, action);
            case 'AUTO_ZONES_SPECTRA_PICKING':
                return ZonesActions.handleAutoSpectraZonesDetection(draft);
            case 'TOGGLE_ZONES_VIEW_PROPERTY':
                return ZonesActions.handleToggleZonesViewProperty(draft, action);
            case 'SAVE_EDITED_ZONE':
                return ZonesActions.handleSaveEditedZone(draft, action);
            case 'ORDER_MULTIPLE_SPECTRA_ANALYSIS':
                return SpectraAnalysisActions.handleOrderSpectra(draft, action);
            case 'RESURRECTING_SPECTRUM_FROM_RANGES':
                return DatabaseActions.handleResurrectSpectrumFromRanges(draft, action);
            case 'RESURRECTING_SPECTRUM_FROM_JCAMP':
                return DatabaseActions.handleResurrectSpectrumFromJcamp(draft, action);
            case 'SET_AUTOMATIC_ASSIGNMENTS':
                return AssignmentsActions.handleSetAutomaticAssignments(draft, action);
            case 'SECRET_THROW_ERROR': {
                throw new Error('Error thrown in main reducer');
            }
            default:
        }
    }
    catch (error) {
        draft.errorAction = error;
        error.data = { action, state: getDebugState(draft) };
        reportError(error);
    }
}
exports.spectrumReducer = (0, immer_1.produce)(innerSpectrumReducer);
function getDebugState(draft) {
    const state = (0, immer_1.original)(draft);
    const string = JSON.stringify(state, (key, value) => {
        if (ArrayBuffer.isView(value)) {
            return Array.from(value).slice(0, 20);
        }
        if (Array.isArray(value) && typeof value[0] === 'number') {
            return value.slice(0, 20);
        }
        return value;
    });
    if (string.length > 800000) {
        // fallback, better to have something as a string t han nothing
        return string.slice(0, 800000);
    }
    return JSON.parse(string);
}
